// ─────────────────────────────────────────────
// HubWire Constants
// ─────────────────────────────────────────────

export const SPONSORSHIP_LEVEL_LABELS: Record<string, string> = {
  platinum: 'Platinum',
  gold: 'Gold',
  silver: 'Silver',
  bronze: 'Bronze',
  community: 'Community Partner',
};

export const SPONSORSHIP_LEVEL_ORDER = ['platinum', 'gold', 'silver', 'bronze', 'community'];

export const EVENT_STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  published: 'Published',
  cancelled: 'Cancelled',
  completed: 'Completed',
};

export const REGISTRATION_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  confirmed: 'Confirmed',
  waitlisted: 'Waitlisted',
  cancelled: 'Cancelled',
};

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  paid: 'Paid',
  refunded: 'Refunded',
  waived: 'Waived',
};

export const ADMIN_ROLE_LABELS: Record<string, string> = {
  owner: 'Owner',
  admin: 'Admin',
  editor: 'Editor',
  viewer: 'Viewer',
};

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Events', path: '/events' },
  { label: 'News', path: '/news' },
  { label: 'Sponsors', path: '/sponsors' },
  { label: 'Contact', path: '/contact' },
];

export const ADMIN_NAV_LINKS = [
  { label: 'Dashboard', path: '/admin' },
  { label: 'Events', path: '/admin/events' },
  { label: 'Registrations', path: '/admin/registrations' },
  { label: 'Sponsors', path: '/admin/sponsors' },
  { label: 'News', path: '/admin/news' },
  { label: 'Settings', path: '/admin/settings' },
];
